import { render, staticRenderFns } from "./SchoolLogoMarquee.vue?vue&type=template&id=15601334&scoped=true&"
import script from "./SchoolLogoMarquee.vue?vue&type=script&lang=js&"
export * from "./SchoolLogoMarquee.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLogoMarquee.vue?vue&type=style&index=0&id=15601334&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15601334",
  null
  
)

export default component.exports